module.exports = __webpack_public_path__ + "static/media/selectedPin.3c440f81.svg";